import { render, staticRenderFns } from "./EditProgramQuestionRatings.vue?vue&type=template&id=0c7e202a"
import script from "./EditProgramQuestionRatings.vue?vue&type=script&lang=js"
export * from "./EditProgramQuestionRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports